import React from 'react';
import { WizardLayout } from 'components/layouts';
import useFetch from 'components/useFetch';
import wizard from './wizardData';

import './Disclaimer.css';

const Notices = () => {
    const [legalDisclaimer, loading] = useFetch({ url: '/api/settings/legals' });

    return (
        <WizardLayout wizard={wizard}>
            {!loading ? (
                // eslint-disable-next-line react/no-danger
                <div className="container disclaimer" dangerouslySetInnerHTML={{ __html: legalDisclaimer.notices }} />
            ) : null}
        </WizardLayout>
    );
};

export default Notices;
